import moment from "moment";

export function assessmentTimeHelper(time) {
    if (!time) return null;
    const [hours, minutes] = time.split(":").map(Number);

    let dateObj = new Date();
    dateObj.setUTCHours(hours + 5);
    dateObj.setUTCMinutes(minutes + 30);

    // Get local time values
    const localHours = dateObj.getUTCHours();
    const localMinutes = dateObj.getUTCMinutes();
    // Convert to 12-hour format
    const displayHours = ((localHours + 11) % 12 + 1); // Converts 0–23 to 1–12
    console.log("displayHours", displayHours)
    const am_pm = localHours >= 12 ? "pm" : "am";
    const paddedMinutes = localMinutes.toString().padStart(2, "0");

    const outputDateString = `${displayHours}:${paddedMinutes} ${am_pm.toLocaleUpperCase()}`;

    return outputDateString;
}


export function assessmentDateHelper(a) {
    if (!a) return null;
    const dateObj = new Date(a);
    const outputDateString = moment(a).format('DD/MM/YYYY')
    return outputDateString;
};

export function getCurrentFormattedDate(date) {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];

    // const currentDate = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const dayOfWeek = daysOfWeek[date.getDay()];
    const formattedDate = `${day} ${month} ${year}, ${dayOfWeek}`;
    return formattedDate;
}